export default {
    NavLinks: 'casbase/v1/get_header/?country=',
    Footer: 'casbase/v1/get_footer',
    HomePage: 'casbase/v1/home/?country=',
    Body: 'casbase/v1/get_body/?resource_id=',
    Search: 'casbase/v1/search/?s=',
    ArticleVote: 'casbase/v1/article_vote/?resource_id=',
    Archive: 'wpvue/v1/archive/',
}


// WEBPACK FOOTER //
// ./src/api/EndPoints.js